// SPDX-FileCopyrightText: 2026 Neptuwunium
//
// SPDX-License-Identifier: EUPL-1.2

import { VoreCore } from '../Core.js'
import { MapSystem } from './Runtime.js'

VoreCore.Initialize(async (core: VoreCore) => {
	const map = new MapSystem(core)
	await map.Load()
	setTimeout(map.LoadAll.bind(map), 1)
})
